import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { IDenunciaDTO, IGetDenunciasProps } from "../../../types/denuncia";
import { Denuncia } from "../../../services/Denuncia";
import { IPagination } from "../../../types/pagination";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { TIPOS_DE_ASSEDIOS } from "../../../constants/tipos_de_assedios";
import { resetValues } from "../../../utils/resetObject";

const TipoAssedioOptions = Object.keys(TIPOS_DE_ASSEDIOS).map((key) => ({
  label: TIPOS_DE_ASSEDIOS[key as keyof typeof TIPOS_DE_ASSEDIOS],
  value: key,
}));
export const useReports = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const navigate = useNavigate();
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const [filter, setFilter] = useState<IGetDenunciasProps>(
    {} as IGetDenunciasProps
  );
  const { setIsLoad } = useContextSite();
  const [denuncias, setDenuncias] = useState<IDenunciaDTO[]>(
    [] as IDenunciaDTO[]
  );

  const updateFilter = (props: Partial<IGetDenunciasProps>) => {
    setFilter((prev) => ({ ...prev, ...props }));
  };

  function getDenuncias(props: IGetDenunciasProps) {
    setIsLoad(true);
    Denuncia.get({ ...props, size: 5 })
      .then(({ data }) => {
        setDenuncias(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.totalElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleClearFilter() {
    const newValue = resetValues(filter);
    setFilter(newValue);
    if (numberPage > 0) {
      setNumberPage(0);
      return;
    }
    getDenuncias({ page: 0, ...newValue });
  }

  function handleFillter(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (numberPage > 0) {
      setNumberPage(0);
      return;
    }

    getDenuncias({ page: 0, ...filter });
  }

  useEffect(() => {
    getDenuncias({ page: numberPage, ...filter });
  }, [numberPage]);

  return {
    filterOpen,
    setFilterOpen,
    isMobile,
    navigate,
    pagination,
    setNumberPage,
    filter,
    updateFilter,
    denuncias,
    TipoAssedioOptions,
    handleClearFilter,
    handleFillter,
  };
};
